<template>
  <div
    class="artist-info"
    v-if="artist"
  >
    <div class="artist-info__table">
      <div class="artist-info__left-column">
        <div class="artist-info__top">
          <div class="artist-info__photo-container">
            <div
              class="artist-info__photo"
              v-bind:style="{ backgroundImage: 'url(' + artist.photo + ')' }"
              :class="{photoContentWithoutPhoto: !artist.photo}"
              tabindex="0"
              aria-label="Zdjęcie artysty"
            >
            </div>
          </div>
          <div
            class="artist-info__artist-name"
            tabindex="0"
            :aria-label="artist.name"
          >
            {{artist.name}}
          </div>
        </div>
        <div
          class="artist-info__photo-description"
          v-if="artist.description"
          tabindex="0"
          :aria-label="artist.description"
        >
          {{artist.description}}
        </div>
        <div
          class="artist-info__content"
        >
        </div>
      </div>
      <div class="artist-info__right-column">
        <div class="artist-info__music">
          <div class="artist-info__music-pink-square">

          </div>
          <div
            class="artist-info__music-title"
            tabindex="0"
            aria-label="Lista utworów"
          >
            utwory na liście
          </div>
        </div>
        <div class="artist-info__song-list">
          <div
            class="artist-info__song"
            v-for="(song, index) in songs"
            :key="index"
            @click="()=>{goToSong(song.id)}"
            v-on:keyup.enter="()=>{goToSong(song.id)}"
          >
            <div class="artist-info__song-dot">
            </div>
            <p
              tabindex="0"
              :aria-label="'przejdź do strony piosenki' + song.name"
            >
              {{song.name}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';

export default {
mixins: [mixin]
}
</script>

<style lang="scss" scoped>
  .artist-info {
    width: 100%;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    margin-top: 2rem;
    &__table{
      display: flex;
      max-width: 1200px;
    }
    &__left-column {
      width: 55rem;
      background-color: #fefefe;
      padding: 3rem 1rem 3rem 1rem;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &__top {
      display: flex;
    }
    &__artist-name {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 1.3rem;
      font-weight: 700;
      padding-bottom: 0.5rem;
      margin-left: 2rem;
    }
    &__photo {
      width: 18.125rem;
      height: 10rem;
      border: 1px solid #e13368;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &__photo-description {
      font-size: 0.9rem;
      font-family: 'Poppins', sans-serif;
      padding-top: 1rem;
      line-height: 1.7;
    }
    &__right-column {
      width: 22rem;
      background-color: #28233a;
      padding: 3rem 1rem 1rem 1rem;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &__music-title {
      color: #d0d0e0;
      text-transform: uppercase;
      font-size: 1.2rem;
      font-family: 'Poppins', sans-serif;
      font-weight: 700;
      padding-bottom: 0.5rem;

    }
    &__song {
      cursor: pointer;
      color: #d0d0e0;
      font-size: 0.9rem;
      font-family: 'Poppins', sans-serif;
      padding-bottom: 1rem;
      display: flex;
      align-items: center;
    }
    &__song-dot {
      width: 0.4rem;
      height: 0.4rem;
      background-color: #d0d0e0;
      border-radius: 100%;
      margin-right: 1rem;
    }
    &__music {
      display: flex;
      margin-bottom: 2rem;
    }
    &__music-pink-square {
      width: 1rem;
      height: 1rem;
      background-color: #df2860;
      margin-right: 1rem;
    }
    &__song:hover {
      color: #df2860;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
  }
</style>
